import React from "react";

// ASSETS
import Illustration from "assets/icons/Deco corner homepage _ About Board DSU_.svg";

// STYLES
import {
  CardContainer,
  CardContent,
  CardIllustration,
  CardImage,
  CardTitle,
  TitleRow,
} from "./HomePageCustomCardStyled";

// LIBRARIES

// MISC
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { CardProps, CardType } from "./HomePageCustomCardModel";
// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const HomePageCustomCard: React.FC<CardProps> = ({
  type,
  content,
  colSpan,
  rowSpan,
}) => {
  // PROPERTIES

  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <CardContainer colSpan={colSpan} rowSpan={rowSpan} type={type}>
      {type === CardType.Image && <CardImage src={content} alt="Card image" />}
      {type === CardType.Title && (
        <CardIllustration src={Illustration} alt="" />
      )}
      {type === CardType.Title && (
        <CardTitle>
          <CustomText text={content} type={TextType.H3} color={COLORS.Yellow} />
        </CardTitle>
      )}
      {type === CardType.Content && (
        <CardContent>
          <TitleRow>
            <CustomText
              text={content.title}
              type={TextType.H3}
              color={COLORS.Cultured}
            />
          </TitleRow>

          <CustomText
            text={content.paragraph}
            type={TextType.P1}
            color={COLORS.Background}
          />
        </CardContent>
      )}
    </CardContainer>
  );
};

export default HomePageCustomCard;
